import RejectCondidateModal from './RejectCondidateModal.component';

export default RejectCondidateModal;
